<template>

  <ui-prop-value-selector :block="block" name="dataSource" title="Data source" :is-array="true" :only-var-type="['object']" :parent-diagram-id="diagram_id"/>
  <ui-prop-value-selector :block="block" name="field" only-var-type="string" title="Selected rows" :parent-diagram-id="diagram_id"/>
  <ui-data-props v-if="defaultSchema" name="fields" :default-schema="defaultSchema" :block="block"/>
  <ui-dynamic-props :default-value="{}" :block="block" :product_id="product_id" :module_id="module_id" />

  <ui-prop-select
      title="View type"
      name="viewType"
      :block="block"
      :options="viewTypes"
      default-value="table"
  />

</template>

<script>
import UiDynamicProps from "@/components/DiagramDesigner/Editor/properties/UiDynamicProps";
import UiPropValueSelector from "@/components/DiagramDesigner/Editor/properties/UiPropValueSelector.vue";
import {propertiesMixins} from "@/components/DiagramDesigner/Editor/properties/propertiesMixins";
import UiDataProps from "@/components/DiagramDesigner/Editor/properties/UiDataProps.vue";
import UiPropSelect from "@/components/DiagramDesigner/Editor/properties/UiPropSelect.vue";

export default {
  mixins: [propertiesMixins],
  name: "TableViewPropsCmp",
  props: ['block'],
  components: {UiPropSelect, UiDataProps, UiPropValueSelector, UiDynamicProps},
  data: () => ({
    defaultSchema: false,
    viewTypes: [
      {label: 'Table', value: 'table'},
      {label: 'Grid', value: 'grid'},
    ]
  }),

  created() {
    // Init default schema
    this.defaultSchema = [
      {
        name: "name",
        type: "string",
        title: "Field name"
      },
      {
        name: "type",
        type: "select",
        title: "Field type",
        options: this.globals.options.db_data_types
      },
      {
        name: "title",
        type: "string",
        title: "Field title"
      },
    ]
  }
}

</script>

